import { APP_NAME } from '@en3/shared';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/routes';

/**
 * 版权与数据来源声明。
 *
 * 这一页是合规要求的一部分（DoD 第 16 项）：明确写出平台不内置受版权保护的教材全文、
 * 正文来源与授权责任、第三方数据署名、以及权利人的下架通道。
 */
export function CopyrightPage() {
  return (
    <section className="mx-auto max-w-3xl px-5 py-10">
      <h1 className="text-2xl font-bold">版权与数据来源</h1>

      <div className="mt-6 space-y-6 text-sm leading-relaxed">
        <div>
          <h2 className="font-semibold">一、关于教材内容</h2>
          <p className="mt-1 text-muted-foreground">
            {APP_NAME}（下称「本平台」）<b>不内置、不抓取、不存储</b>受版权保护的《大学英语》系列教材全文。
            本平台只收录公开可见的<b>目录元数据</b>（教材名、册次、单元标题等）与自撰示例文章，
            用于组织学习结构。
          </p>
        </div>

        <div>
          <h2 className="font-semibold">二、正文来源与授权责任</h2>
          <p className="mt-1 text-muted-foreground">
            文章正文由具备相应使用授权的教师或用户自行导入。导入时必须勾选「我拥有该文本的使用授权」，
            该确认会连同版权状态一并写入数据库留痕。导入者对其导入内容承担全部责任；
            如无授权，请勿导入受版权保护的作品。
          </p>
        </div>

        <div>
          <h2 className="font-semibold">三、权利人下架通道</h2>
          <p className="mt-1 text-muted-foreground">
            若你认为本平台上的某条内容侵犯了你的权利，请通过页面底部的联系方式告知。
            我们会在核实后把该文章的版权状态标记为 <code className="rounded bg-muted px-1">takedown</code>，
            前端将立即不可见，并保留处理记录。
          </p>
        </div>

        <div>
          <h2 className="font-semibold">四、第三方数据来源与署名</h2>
          <ul className="mt-1 space-y-1 text-muted-foreground">
            <li>• 英文释义、音标、例句与发音：Free Dictionary API（数据源自 Wiktionary，CC BY-SA 授权）。</li>
            <li>• 中文释义与分级：平台内置的分级词表（含 CEFR 等级与词频信息）。</li>
            <li>• 长难句解析、学习建议等生成式结果：由 Cloudflare Workers AI 或兼容的第三方大模型生成，仅供参考。</li>
          </ul>
        </div>

        <div>
          <h2 className="font-semibold">五、你的数据</h2>
          <p className="mt-1 text-muted-foreground">
            我们只保存学习所必需的数据：账号信息、查词与标记记录、复习记录、阅读进度。
            不保存原始 IP（只保留加盐哈希用于限流与去重），不记录请求正文。
            你可以在个人中心退出登录，或申请删除账号与全部学习数据。
          </p>
        </div>

        <div>
          <h2 className="font-semibold">六、免责声明</h2>
          <p className="mt-1 text-muted-foreground">
            本平台的词典释义、机器翻译与 AI 解析结果可能存在错误，不构成教学或考试的权威依据，
            也不对由此产生的后果承担责任。
          </p>
        </div>
      </div>

      <p className="mt-8 text-sm">
        <Link className="text-primary underline underline-offset-4" to={ROUTES.home}>
          返回首页
        </Link>
      </p>
    </section>
  );
}
